import AccessTimeIcon from '@mui/icons-material/AccessTime';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import PeopleAltOutlinedIcon from '@mui/icons-material/PeopleAltOutlined';
import moment from 'moment';
import { useStyles } from '../../styles';
import { Box, Grid, Typography } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { RegisteredEventCards } from '../../utils/interfaces';
import { AppButton } from '../../globalComponent/AppButton';
import routes from '../../../../Utils/routes';
import KenColors from '../../utils/kenColors';
// import NoDataImg from '../../../../Assets/noDataImg.png';

const RegisteredEventCardsList: React.FunctionComponent<{ data: any; status: 'cancelled' | 'completed' | 'upcoming'; handleOpen?: (arg: any) => {}; }> = ({ data, status, handleOpen }) => {
  const classes = useStyles();
  const navigate = useHistory();
  console.log('RegisteredEventCards', data);
  const isMobile = window.innerWidth <= 600; // Adjust this value based on your design breakpoints
  const CardAction: React.FunctionComponent<{
    status: 'cancelled' | 'completed' | 'upcoming';
    data: any;
  }> = ({ status, data }) => {
    switch (status) {
      case 'cancelled':
        return null;
      case 'completed':
        console.log(data, "dddddaaatttaa");

        return (
          <AppButton disabled={data?.feedbackSubmitted == true ? true : false} onClick={() => handleOpen && handleOpen(data.sessionId)} fullWidth others={{ color: KenColors.ClientBlue9, borderRadius: '9px', height: '30px', fontSize: '12px' }} background={KenColors.ClientBlue4}>
            Submit feedback
          </AppButton>
        );
      case 'upcoming':
        return (
          <AppButton
            fullWidth
            others={{ color: KenColors.ClientBlue9, borderRadius: '9px', height: '30px', fontSize: '12px' }}
            background={KenColors.ClientBlue4}
            onClick={() => {
              navigate.push(`${routes.eventDetail}/${data?.id}`);
            }}
          >
            View Details
          </AppButton>
        );
      default:
        break;
    }
  };

  const formatTo12HourTime = (timeString: string | null | undefined) => {
    if (!timeString) return ""; // Return empty string if null/undefined

    const [hour, minute] = timeString.split(":").map(Number);
    if (isNaN(hour) || isNaN(minute)) return ""; // Handle invalid time values

    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;
    return `${formattedHour.toString().padStart(2, "0")}:${minute.toString().padStart(2, "0")} ${period}`;
  };

  const startTime = formatTo12HourTime(data?.startTime);
  const endTime = formatTo12HourTime(data?.endTime);

  return (
    <Box className={classes.card}>
      <Grid container spacing={4} alignItems={'center'}>
        <Grid item lg={3} md={2} width={'100%'}>
          {data.img == 'https://inazstgpfs3001.blob.core.windows.net/assets/Kenverse/Alumni/Images/noimage.jpg' ? (
            <img className={classes.image} src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg==" alt="Upcoming Event" />
          ) : (
            <img className={classes.image} src={data.img} alt="Upcoming Event" />
          )}
        </Grid>
        {isMobile ? (
          <Grid item xs={12} width="100%">
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              {/* Event Title */}
              <Typography
                className={classes.registerEventTitle}
                color={KenColors.ClientBlack1}
                style={{ fontWeight: 600, fontSize: 18, marginBottom: 4 }}
              >
                {data.title}
              </Typography>

              {/* Category */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <Typography
                  className={classes.registerEventTitleType}
                  color={KenColors.ClientBlack1}
                  style={{ fontWeight: 500 }}
                >
                  Category:
                </Typography>
                {data.category.map((item: string, idx: number) => (
                  <Typography
                    key={idx}
                    className={classes.registerEventCategory}
                    color={KenColors.ClientBlack1}
                    style={{
                      padding: '0 6px',
                      borderLeft: idx === 0 ? 'none' : `1px solid ${KenColors.ClientBlack1}`,
                      fontWeight: 400,
                    }}
                  >
                    {item}
                  </Typography>
                ))}
              </div>

              {/* Date & Time */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <AccessTimeIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} fontSize="small" />
                <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                  {data.startDate}
                </Typography>
              </div>

              {/* Event Mode */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <LocationOnOutlinedIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} fontSize="small" />
                <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                  Event mode: {data.location}
                </Typography>
              </div>

              {/* Suitable For */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <PeopleAltOutlinedIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} fontSize="small" />
                <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                  Suitable for: {data.suitablefor}
                </Typography>
              </div>
            </div>
          </Grid>
        ) : (
          <>
            <Grid item lg={7} md={12} width={'100%'}>
              <div className={`d-flex flex-column gap-3 w-100`}>
                <div className="d-flex align-items-start gap-3 w-100">
                  <div className="d-flex align-items-start gap-2 flex-nowrap w-100 justify-content-between">
                    <div className="d-flex flex-column gap-2">
                      <Typography className={classes.registerEventTitle} color={KenColors.ClientBlack1}>
                        {data.title}
                      </Typography>
                      <div className="d-flex align-item-center">
                        <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                          Category:{' '}
                        </Typography>
                        {data.category.map((items: string, index: number) => {
                          return (
                            <Typography
                              key={index}
                              borderLeft={index === 0 ? 'none' : `1px solid ${KenColors.ClientBlack1}`}
                              className={classes.registerEventCategory}
                              color={KenColors.ClientBlack1}
                              padding={'0px 3px'}
                            >
                              {items}
                            </Typography>
                          );
                        })}
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex gap-1 align-item-center">
                        <AccessTimeIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} />
                        <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                          {data.startDate}
                          {/* {`${startTime} - ${endTime}`} */}
                        </Typography>
                      </div>
                      <div className="d-flex gap-1 align-item-center">
                        <LocationOnOutlinedIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} />
                        <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                          {`Event mode: ${data.location}`}
                        </Typography>
                      </div>
                    </div>
                    <div className="d-flex flex-column gap-2">
                      <div className="d-flex gap-1 align-item-center">
                        <PeopleAltOutlinedIcon className={classes.accordionDetailsIcon} color={KenColors.ClientIconBlack as any} />
                        <Typography className={classes.registerEventTitleType} color={KenColors.ClientBlack1}>
                          {`suitablefor: ${data.suitablefor}`}
                        </Typography>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
          </>
        )}
        <Grid item lg={2} md={12} width={'100%'} sx={{
          '@media (min-width: 1240px) and (max-width: 1280px)': {
            paddingTop: '10px !important',
            paddingLeft: '10px !important',
          },
        }}>
          <CardAction status={status} data={data} />
        </Grid>
      </Grid>
    </Box>
  );
};

export default RegisteredEventCardsList;
